import { useMemo } from 'react'

export function useWindow() {
  const window_ = useMemo(() => typeof window !== `undefined` ? window : null)
  return window_
}

export default useWindow
